// extracted by mini-css-extract-plugin
module.exports = {"comp":"BackupSystemSection_comp__1Q3bF"};